import { Views } from '@singularsystems/neo-react';
import { AppService } from '../../../../App/Services/AppService';
import { Types } from '../../../../AccessControl/AccessControlTypes';
import AuthorisableUpdateRequestSearchCriteria from '../Models/Queries/AuthorisableUpdateRequestSearchCriteria';
import { Data, Misc, ModalUtils, NeoModel } from '@singularsystems/neo-core';
import AuthorisableUpdateRequestBatchLookup from '../Models/Lookups/AuthorisableUpdateRequestBatchLookup';
import { TextConstants } from '../../../../Common/TextConstants';
import DeclineRequestCommand from '../Models/Commands/DeclineRequestCommand';
import { request } from 'http';
import ProcessBatchCommand from '../Models/Commands/ProcessBatchCommand';
import DeclineBatchCommand from '../Models/Commands/DeclineBatchCommand';

@NeoModel
export default class AuthorisableUpdateRequestsByStatusVM extends Views.ViewModelBase {
    public authorisableUpdateStatus: string = "Pending"
    public authorisableUpdateRequestSearchCriteria = new AuthorisableUpdateRequestSearchCriteria();
    public isPending: boolean = true;
    
    public authorisableUpdateRequestPageManager = new Data.PageManager(this.authorisableUpdateRequestSearchCriteria, AuthorisableUpdateRequestBatchLookup,
        this.authorisableUpdateRequestApiClient.getAuthorisableUpdateRequests, {
        pageSize: 10,
        sortAscending: true,        
        fetchInitial: true,
        sortBy: "authorisableUpdateRequestBatchId",
        initialTaskRunner: this.taskRunner,
        afterFetch: this.setImportIsExpandedProp.bind(this),
        beforeFetch: this.setAuthorisableStatus.bind(this)
    });

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public authorisableUpdateRequestApiClient = AppService.get(Types.ApiClients.AuthorisableUpdateRequestApiClient),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications)) {

        super(taskRunner);        
    }

    public initialise(): void {    
    }

    public setAuthorisableStatus() {
        this.authorisableUpdateRequestSearchCriteria.status = this.authorisableUpdateStatus;
        this.isPending = this.authorisableUpdateStatus === TextConstants.GeneralText.Pending ? true : false;
    }
    
    public setImportIsExpandedProp(data: AuthorisableUpdateRequestBatchLookup[]) {
        data.forEach(batch => {
            if (batch.authorisableUpdateableTableRequestLookups.length > 0) {
                batch.isExpanded = false;
            }
        })
    }

    public async declineRequest(requestId: number) {
        let command = new DeclineRequestCommand();
        command.requestId = requestId;
        await this.authorisableUpdateRequestApiClient.declineRequest(command);      
        this.authorisableUpdateRequestPageManager.refreshData();
    }
    
    public async processRequestsByBatch(batchId: number, staticServiceProviderId: number) {
        if(await ModalUtils.showYesNo(
            `${TextConstants.GeneralText.ProcessBatch}`,
            `${TextConstants.GeneralText.ProcessBatchQuestion}`)
            === Misc.ModalResult.Yes){
                let command = new ProcessBatchCommand();
                command.batchId = batchId;
                command.staticServiceProviderId = staticServiceProviderId;
                await this.authorisableUpdateRequestApiClient.processBatch(command)
                this.authorisableUpdateRequestPageManager.refreshData();
            }                
    }

    public async declineBatch(batchId: number) {
        if(await ModalUtils.showYesNo(
            `${TextConstants.GeneralText.DeclineBatch}`,
            `${TextConstants.GeneralText.DeclineBatchQuestion}`)
            === Misc.ModalResult.Yes){
               let command = new DeclineBatchCommand();
               command.batchId = batchId;
               await this.authorisableUpdateRequestApiClient.declineBatch(command);
               this.authorisableUpdateRequestPageManager.refreshData();
            }        
    }

    public async clearSearch() {
        this.authorisableUpdateRequestSearchCriteria.meta.status.value = "";
        await this.authorisableUpdateRequestPageManager.refreshData();
    }

    public async load(authorisableUpdateStatus: string) {
        this.authorisableUpdateStatus = authorisableUpdateStatus;       
    }   
}